// extracted by mini-css-extract-plugin
export default {"checkbox":"UrlAuthModal-module__checkbox"};